export default __webpack_public_path__ + "static/media/back-arrow-white.a9d976b7.svg";